import { useTranslation } from "react-i18next";
import { storedLocale } from "../../../components/Authentication/util";
import { getBigEndianTimestamp, getFormattedTimestamp } from "../../util/getTimestamp";
import commonContent from "../../../content/common";
import "./TimeStamp.scss";

type Props = {
  dateFormat: "long" | "short" | "bigEndian";
};

/**
 * Returns common Timestamp with translations and styles.
 *
 * dateFormat: "long" = "Totals as of April 16, 2024 at 13:50 EDT"
 * dateFormat: "short" = "Totals as of Apr 16, 2024 at 13:50 EDT"
 * dateFormat: "bigEndian" = "Last updated at 12:30am on 2025/08/29"
 */
export const TimeStamp = ({ dateFormat }: Props) => {
  const { t } = useTranslation(["common"]);
  const locale = storedLocale();
  const { longDate, shortDate } = getFormattedTimestamp(locale);
  const { time: bigEndianTime, date: bigEndianDate } = getBigEndianTimestamp(locale);

  const renderTimeFormat = (date: string) => (
    <p id={`${dateFormat}Date-timestamp`} className={`TimeStamp`}>
      {t("totalsAsOf", commonContent["totalsAsOf"], { ns: "common", timestamp: date })}
    </p>
  );

  const renderBigEndianFormat = () => (
    <p id="bigEndianDate-timestamp" className="TimeStamp">
      {t("lastUpdatedAt", commonContent["lastUpdatedAt"], { ns: "common", time: bigEndianTime, date: bigEndianDate })}
    </p>
  );

  return (
    <>
      {dateFormat === "long" && renderTimeFormat(longDate)}
      {dateFormat === "short" && renderTimeFormat(shortDate)}
      {dateFormat === "bigEndian" && renderBigEndianFormat()}
    </>
  );
};
